import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAdmin } from '../context/AdminContext';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { adminData, logout } = useAdmin();
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setUserMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleAdminLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
      navigate('/login');
    }
  };

  return (
    <nav className="glass border-b border-red-500/20 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8">
        <div className="flex items-center justify-between h-14 sm:h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2 sm:space-x-3">
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-red-400 to-purple-600 rounded-lg flex items-center justify-center shadow-lg shadow-red-500/50">
                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                        d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h1 className="text-xl sm:text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-purple-500">
                BSA Admin
              </h1>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden sm:flex items-center space-x-4">
            <Link
              to="/conversations"
              className={`px-4 py-2 rounded-lg transition-all duration-300 ${
                location.pathname === "/conversations"
                  ? "bg-gradient-to-r from-red-500 to-purple-600 text-white shadow-lg shadow-purple-500/50"
                  : "text-gray-300 hover:text-white hover:bg-white/10"
              }`}
            >
              Dashboard
            </Link>

            {/* Admin Profile */}
            {adminData && (
              <div className="relative" ref={userMenuRef}>
                <button
                  onClick={() => setUserMenuOpen(!userMenuOpen)}
                  className="flex items-center space-x-2 px-4 py-2 rounded-lg hover:bg-white/10 transition-colors duration-300"
                >
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-red-400 to-purple-600 flex items-center justify-center">
                    <span className="text-white text-sm font-bold">
                      {adminData.name ? adminData.name[0].toUpperCase() : 'A'}
                    </span>
                  </div>
                  <span className="text-gray-300 text-sm">
                    {adminData.email}
                  </span>
                </button>

                {userMenuOpen && (
                  <div className="absolute right-0 mt-2 w-48 glass rounded-lg shadow-xl border border-red-500/30 overflow-hidden animate-fadeIn">
                    <div className="px-4 py-3 border-b border-red-500/20">
                      <p className="text-sm text-white font-medium">Admin Account</p>
                      <p className="text-xs text-gray-400 truncate">{adminData.email}</p>
                    </div>
                    <button
                      onClick={handleAdminLogout}
                      className="w-full px-4 py-2 text-left text-sm text-gray-300 hover:text-white hover:bg-red-500/20 transition-colors duration-300"
                    >
                      <div className="flex items-center space-x-2">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                        </svg>
                        <span>Sign Out</span>
                      </div>
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="sm:hidden">
            <button
              onClick={() => setUserMenuOpen(!userMenuOpen)}
              className="p-2 rounded-lg hover:bg-white/10 transition-colors duration-300"
            >
              <svg className="w-6 h-6 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                      d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
